module.exports = __webpack_public_path__ + "static/media/14.d7d5db88.jpg";